<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn :class="buttonClass" :color="color" icon v-bind="attrs" v-on="on">
        <v-icon
          id="user-profile"
          :large="large"
          :small="small"
          :x-large="xLarge"
          :x-small="xSmall"
          v-bind="attrs"
        >
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <v-list dense width="250">
      <slot />
      <v-list-item
        v-for="(item, index) in links"
        :key="item.id + index"
        @click="executeLink(item)"
      >
        {{ item.text }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import Vue from "vue";
import router from "@/router";

export default Vue.extend({
  name: "LinkDropdown",
  props: {
    links: {
      type: Array
    },
    icon: {
      type: String,
      default: "mdi-dots-vertical"
    },
    buttonClass: {
      type: String
    },
    xSmall: {
      type: Boolean
    },
    small: {
      type: Boolean
    },
    large: {
      type: Boolean
    },
    xLarge: {
      type: Boolean
    },
    color: {
      type: String,
      default: "white"
    }
  },
  methods: {
    executeLink(item) {
      if (item.href) {
        if (item.href === "/logout" || item.href === "/user/index") {
          window.location.href = item.href;
        } else {
          router.push(item.href);
        }
      } else if (item.callback) {
        item.callback();
      }
    }
  }
});
</script>
